import Vue from "vue";

import NotificationSettingsForm from "./NotificationSettingsForm.vue";

export function load() {
    const selector = "notification-settings-form";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(NotificationSettingsForm, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
